import { Login } from "../../components/login/Login";

export const LoginPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center", 
        marginTop: "50px"
      }}
    >
      <Login />
    </div>
  );
};
